import {
    fetchUserMeAgreement,
    fetchUserMeSettings,
    resetClientAuthToken, updateUserAgreement,
    updateUserSettings
} from "../../api/AlfyApiClient";
import {useRecoilValue, useSetRecoilState} from "recoil";
import {userState} from "./userAtom";
import {QUERY_KEYS} from "../query-keys";
import {QueryClient, useMutation, useQuery, useQueryClient} from "react-query";
import {useNavigate} from "react-router-dom";
import {UpdateUserAgreementRequest, UpdateUserSettingsRequest} from "../../models/User";

export const useLogout = () => {
    const setUser = useSetRecoilState(userState);
    const navigate = useNavigate();
    const queryClient = new QueryClient();

    const logout = () => {
        resetClientAuthToken();
        setUser(null);
        queryClient.removeQueries(QUERY_KEYS.MEMBER)
        navigate("/login");
    }

    return { logout };
}

export const useGetUserMeSettings = () => {
    return useQuery(
        [QUERY_KEYS.USER_SETTINGS],
        async () => {
            return await fetchUserMeSettings()
        },
        {
            onError: (error: any) => {
                console.error(error)
            }
        }
    )
}

export const useGetUserMeAgreements = () => {
    return useQuery(
        [QUERY_KEYS.USER_AGREEMENTS],
        async () => {
            return await fetchUserMeAgreement()
        },
        {
            onError: (error: any) => {
                console.error(error)
            }
        }
    )
}

export const useUpdateSettings = () => {
    const queryClient = useQueryClient()
    const user = useRecoilValue(userState) // TODO props로 받아오기
    const userId = user?.id ?? ''

    return useMutation(
        async (request: UpdateUserSettingsRequest) => {
            return await updateUserSettings(userId, request)
        },
        {
            onSuccess: () => {
                queryClient.invalidateQueries(QUERY_KEYS.USER_SETTINGS)
            }
        }
    )
}

export const useUpdateAgreements = () => {
    const queryClient = useQueryClient()
    const user = useRecoilValue(userState) // TODO props로 받아오기
    const userId = user?.id ?? ''

    return useMutation(
        async (request: UpdateUserAgreementRequest) => {
            return await updateUserAgreement(userId, request)
        },
        {
            onSuccess: () => {
                queryClient.invalidateQueries(QUERY_KEYS.USER_AGREEMENTS)
            }
        }
    )
}